import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  > span {
    font-size: 12px;
    font-weight: 300;
    color: #EE1B24;
    margin-left: auto;
  }

  form {
    div + div {
      margin-top: 20px;
    }
  }

  small {
    font-size: 12px;
    font-weight: 400;
    color: ${theme.textDark};
    margin-top: 20px;
  }

  button {
    width: min-content;
    margin: 20px 0 0 auto;
  }
`;

export { Container };